import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import ShipBackItem from "./shipBackItem";
import ShipBackShipment from "./shipBackShipment";
import {
  getShipBackText,
  isShipBack,
  getLsItemShippingInfo,
  clearLsItemsShippingInfo,
  setLsItemsShippingInfo,
  getStep,
  gridClasses,
  getDocumentId,
} from "./helpers";
import { WorthyThemeProvider } from "@worthy-npm/worthy-ui-components";
import { useDispatch } from "react-redux";
import { updateShipBackAddresses } from "actions/item";
import ShipBackTrackingCode from "./shipBackTrackingCode";
import { ErrorAlert } from "@worthy-npm/clarity";
import ShipBackNeedOTPVerificationSuccessAlert from "./shipBackNeedOTPVerificationSuccessAlert";

const ShipBack = (props) => {
  const dispatch = useDispatch();
  const {
    item,
    item: { id, shipback_info },
  } = props;
  const step = getStep(shipback_info.bundle_workflow_state);
  const isReleaseFormSigned = !!shipback_info.document_id;
  const isDirect = shipback_info.shipping_option === "direct";
  const showSignFormBanner = isDirect && !isReleaseFormSigned;
  const [isLoading, setIsLoading] = useState(step === 0);

  useEffect(() => {
    const initAddresses = async () => {
      if (step > 0) {
        clearLsItemsShippingInfo(shipback_info);
        return;
      }
      setIsLoading(true);

      const addresses = getLsItemShippingInfo(id);
      const document_id = getDocumentId(addresses);

      const { payload } = await dispatch(
        updateShipBackAddresses(id, {
          address: shipback_info.address,
          ...addresses,
          document_id,
        })
      );
      setLsItemsShippingInfo(shipback_info, payload);

      setIsLoading(false);
    };

    initAddresses();
  }, [id, step]);

  if (isLoading || !shipback_info) {
    return null;
  }

  return (
    <WorthyThemeProvider>
      <div className="shipBack--container ">
        <div className="shipBack--alert-wrapper">
          {showSignFormBanner && (
            <ErrorAlert
              onClose={() => {}}
              TextComponent={() => (
                <div
                  dangerouslySetInnerHTML={{
                    __html: getShipBackText("bannerSignForm"),
                  }}
                />
              )}
            />
          )}
        </div>
        <ShipBackNeedOTPVerificationSuccessAlert {...props} />
        <Grid container spacing={24} classes={gridClasses}>
          <Grid item xs={12} classes={gridClasses}>
            <h1 className="shipBack--header">{getShipBackText("title")}</h1>
          </Grid>
          <Grid item xs={12} classes={gridClasses}>
            <div className="shipBack--text shipBack--text-block shipBack--text-helper">
              {getShipBackText("subTitle")}
            </div>
          </Grid>
          <Grid item md={8} xs={12} classes={gridClasses}>
            <ShipBackItem item={item} />
          </Grid>
          <Grid item md={4} xs={12} classes={gridClasses}>
            <ShipBackShipment item={item} />
            <ShipBackTrackingCode trackingCode={shipback_info?.tracking_code} />
          </Grid>
        </Grid>
      </div>
    </WorthyThemeProvider>
  );
};

export default ShipBack;
